import { ArrowNarrowRightIcon } from '@heroicons/react/outline';
import React from 'react'
import PropTypes from 'prop-types'
import GroupShare from 'components/GroupShare';

export default function CardPostDetail({share,date,lokasi,timeStart,timeLeft,waktu}) {
  return (
    <div className="px-8 py-12 border cardPostWrapper rounded-2xl border-borderCardFeatures">
      <div className="px-6 py-10 mb-16 space-y-3 cardPost bg-blurBorder rounded-2xl">
        <h1 className="text-sm font-bold datePost">Tanggal</h1>
        <p className="text-sm font-normal text-nameColor">
          {/* {date?.substring(0, 10).split("-").reverse().join("-")} */}
          {date}
        </p>
        <h1 className="text-sm font-bold datePost">Waktu</h1>
        <p className="text-sm font-normal text-nameColor">
          {waktu}
        </p>
        <h1 className="text-sm font-bold datePost">Lokasi</h1>
        <p className="text-sm font-normal text-nameColor">{lokasi}</p>
      </div>
      {share ? (
        <GroupShare />
      ) : (
        <button
          className="flex items-center justify-center w-full py-6 text-white rounded-2xl bg-spanBolder fotn-bold"
          type="button"
        >
          Ikuti Kegiatan{" "}
          <ArrowNarrowRightIcon className="w-6 h-6 ml-2 text-white" />
        </button>
      )}
    </div>
  );
}

CardPostDetail.propTypes = {
    share: PropTypes.bool,
}
